import { render, staticRenderFns } from "./IconAppStore.vue?vue&type=template&id=139d32de"
import script from "./IconAppStore.vue?vue&type=script&lang=js"
export * from "./IconAppStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports